import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import moment from "moment";
import {
    employmentStatusSelectOptions,
    payrollClassificationSelectOptions,
} from "../../variables/Variables.jsx";
import { areaSelectOptionRequest } from "../../api/area";
import { companySelectOptionRequest } from "../../api/company";
import { departmentSelectOptionRequest } from "../../api/department";
import {
    fetchEmployeeRequest,
} from "../../api/employee";
import { employeeTypeSelectOptionRequest } from "../../api/employeeType";
import { payscaleSelectOptionRequest } from "../../api/payscale";
import { positionSelectOptionRequest } from "../../api/position";
import { payLevelSelectOptionRequest } from "api/payLevel.js";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect.jsx";

class UpdateForm extends Component {
    constructor(props) {
      super(props);
      this.state = {
        resource: {
          company: null,
          firstName: null,
          middleName: null,
          lastName: null,
          employeeType: null,
          employeeNumber: null,
          dateHired: null,
          dateDischarged: null,
          birthdayDate: null,
          employmentStatus: null,
          dateRegularized: null,
          tinClassification: null,
          tinNumber: null,
          sssNumber: null,
          phicNumber: null,
          hdmfNumber: null,
          ecolaNumber: null,
          payrollClassification: null,
          payLevel: null,
          superior: null,
          department: null,
          position: null,
          locationArea: null,
          locationProvince: null,
          locationCity: null,
          allowancesPerDiem: null,
          allowancesGasoline: null,
          allowancesMeal: null,
          allowancesTelephone: null,
          allowancesOperational: null,
          allowancesTransportation: null,
          allowancesHousing: null,
          allowancesOthers: null,
          monthlyCoopDeduction: null,
          monthlyEmployeeValeDeduction: null,
          monthlyUtilityBillDeduction: null,
          monthlyEducationalLoanDeduction: null,
          monthlyUniformDeduction: null,
          monthlyOtherDeduction: null,
          benefits: null,
          benefitsAccidentInsurance: false,
          benefitsHealthInsurance: false,
          benefitsBirthdayCheck: false,
          benefitsLongevityPay: false,
          benefitsMeritIncrease: false,
          benefitsRiceIncentive: false,
          benefitsSchoolBonus: false,
          benefitsSchoolAssistance: false,
          benefitsUniform: false,
          benefitsRetirementProgram: false,
          benefitsGraduationGift: false,
          benefitsLengthOfServiceIncentive: false,
          benefitsBurialAssistance: false,
          benefitsWeddingGift: false,
          benefitsAnnualSalaryReview: false,
          benefitsAnniversaryBonus: false,
          benefitsRecognitionBonus: false,
          benefitsMidYearBonus: false,
          benefitsYearEndBonus: false,
          benefitsSinulog: false,
          benefitsFlowersAndCandles: false
        },
        areaSelectOptions: [],
        companySelectOptions: [],
        employeeTypeSelectOptions: [],
        payscaleSelectOptions: [],
        superiorSelectOptions: [],
        departmentSelectOptions: [],
        positionSelectOptions: [],
        payLevelSelectOptions: []
      }
    }

    componentDidMount() {
        const { selectedEmployeeId } = this.props;

        if (selectedEmployeeId) {
            this.fetchEmployee(selectedEmployeeId);
        }

        areaSelectOptionRequest(
            (result) => this.setState({ areaSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        companySelectOptionRequest(
            (result) => this.setState({ companySelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        departmentSelectOptionRequest(
            (result) => this.setState({ departmentSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        // employeeSelectOptionRequest(
        //     (result) => this.setState({ superiorSelectOptions: result }),
        //     (error) => this.setState({ error: "There was an error" }),
        // );
        employeeTypeSelectOptionRequest(
            (result) => this.setState({ employeeTypeSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        payscaleSelectOptionRequest(
            (result) => this.setState({ payscaleSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        positionSelectOptionRequest(
            (result) => this.setState({ positionSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        payLevelSelectOptionRequest(
            (result) => this.setState({ payLevelSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
    }

    static getDerivedStateFromProps(props, state) {
        const { selectedEmployeeId } = props;
        const { resource = {} } = state;
        if (selectedEmployeeId !== resource._id) {
            return { resource: { ...resource, _id: selectedEmployeeId } };
        }
        return null;
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.resource._id !== this.state.resource._id) {
            this.fetchEmployee(this.state.resource._id);
        }
    }

    fetchEmployee = (id) => {
        fetchEmployeeRequest(
            id,
            (result) =>
                this.setState((prevState) => ({
                    resource: {
                        ...prevState.resource,
                        ...result,
                    },
                })),
            (error) => this.setState({ error: "There was an error" }),
        );
    };

    handleFormChange = (e) => {
        const { target } = e;
        let { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    handleCheckboxChange = (e) => {
        const { target } = e;
        const { name, checked } = target;
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: checked,
            },
        }));
    };

    handleDateChange = (date, field) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [field]: date,
            },
        }));
    };

    errorMessage = (name, message) => {
        const { formErrors } = this.props;
        return (
            <>
                {formErrors && formErrors[name] && (
                    <div className="form-text text-danger sz-11px">
                        {message}
                    </div>
                )}
            </>
        );
    };

    handleChange = (employeeValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                superior: employeeValue.value,
            },
        }));
    };

    render() {
        const {
            company,
            firstName,
            middleName,
            lastName,
            employeeType,
            employeeNumber,
            dateHired,
            birthdayDate,
            employmentStatus,
            dateRegularized,
            tinClassification,
            tinNumber,
            sssNumber,
            phicNumber,
            hdmfNumber,
            ecolaNumber,
            payrollClassification,
            payLevel,
            dateDischarged,
            department,
            position,
            locationArea,
            locationProvince,
            locationCity,
            allowancesPerDiem,
            allowancesGasoline,
            allowancesMeal,
            allowancesTelephone,
            allowancesOperational,
            allowancesTransportation,
            allowancesHousing,
            allowancesOthers,
            monthlyCoopDeduction,
            monthlyEmployeeValeDeduction,
            monthlyUtilityBillDeduction,
            monthlyEducationalLoanDeduction,
            monthlyUniformDeduction,
            monthlyOtherDeduction,
            benefits,
            benefitsAccidentInsurance,
            benefitsHealthInsurance,
            benefitsBirthdayCheck,
            benefitsLongevityPay,
            benefitsMeritIncrease,
            benefitsRiceIncentive,
            benefitsSchoolBonus,
            benefitsSchoolAssistance,
            benefitsUniform,
            benefitsRetirementProgram,
            benefitsGraduationGift,
            benefitsLengthOfServiceIncentive,
            benefitsBurialAssistance,
            benefitsWeddingGift,
            benefitsAnnualSalaryReview,
            benefitsAnniversaryBonus,
            benefitsRecognitionBonus,
            benefitsMidYearBonus,
            benefitsYearEndBonus,
            benefitsSinulog,
            benefitsFlowersAndCandles
        } = this.state.resource;

        const {
            areaSelectOptions,
            companySelectOptions,
            employeeTypeSelectOptions,
            departmentSelectOptions,
            positionSelectOptions,
            payLevelSelectOptions,
        } = this.state;

        return (
            <Row>
              <Col md={12}>
                <Card
                  title="Update Employee"
                  content={
                    <form>
                      <FormGroup controlId="formControlsSelect">
                        <ControlLabel>Company</ControlLabel>
                        <FormControl 
                            onChange={this.handleFormChange}
                            componentClass="select" 
                            name="company"
                            value={company && company._id}
                          >
                          <option value="">Select</option>
                          {companySelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                        {this.errorMessage('company', "Company can't be empty")}
                      </FormGroup>
                      <Row>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>First Name</ControlLabel>
                            <FormControl
                              type="text"
                              name="firstName"
                              value={firstName}
                              readOnly
                              placeholder=""
                            />
                            {this.errorMessage('firstName', "First name can't be empty")}
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Middle Name</ControlLabel>
                            <FormControl
                              type="text"
                              name="middleName"
                              value={middleName}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Last Name</ControlLabel>
                            <FormControl
                              type="text"
                              name="lastName"
                              value={lastName}
                              readOnly
                              placeholder=""
                            />
                            {this.errorMessage('lastName', "Last name can't be empty")}
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Birthday</ControlLabel>
                            <FormControl
                              type="text"
                              name="birthdayDate"
                              value={birthdayDate ? moment(birthdayDate).format('MM/DD/YYYY') : 'N/A'}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-3">
                          <FormGroup controlId="formControlsSelect">
                            <ControlLabel>Employee Type</ControlLabel>
                            <FormControl 
                                onChange={this.handleFormChange}
                                componentClass="select" 
                                name="employeeType"
                                value={employeeType && employeeType._id}
                              >
                              <option value="">N/A</option>
                              {employeeTypeSelectOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                );
                              })}
                            </FormControl>
                            {this.errorMessage('employeeType', "Employee Type can't be empty")}
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Employment Status</ControlLabel>
                            <FormControl 
                                readOnly
                                componentClass="select" 
                                name="employmentStatus"
                                value={employmentStatus}
                              >
                              <option value="">N/A</option>
                              {employmentStatusSelectOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                );
                              })}
                            </FormControl>
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Payroll Classification</ControlLabel>
                            <FormControl 
                                onChange={this.handleFormChange}
                                componentClass="select" 
                                name="payrollClassification"
                                value={payrollClassification}
                              >
                              <option value="">Select</option>
                              {payrollClassificationSelectOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                );
                              })}
                            </FormControl>
                            {this.errorMessage('payrollClassification', "Payroll Classification can't be empty")}
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Pay Level</ControlLabel>
                            <FormControl 
                                onChange={this.handleFormChange}
                                componentClass="select" 
                                name="payLevel"
                                value={payLevel ? payLevel._id : ''}
                              >
                              <option value="">Select</option>
                              {payLevelSelectOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                );
                              })}
                            </FormControl>
                            {this.errorMessage('payLevel', "Pay Level can't be empty")}
                          </FormGroup>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Employee Number</ControlLabel>
                            <FormControl
                              type="text"
                              name="employeeNumber"
                              value={employeeNumber}
                              readOnly
                              placeholder=""
                            />
                            {this.errorMessage('employeeNumber', "Employee Number can't be empty")}
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Date Hired</ControlLabel>
                            <FormControl
                              type="text"
                              name="dateHired"
                              value={dateHired ? moment(dateHired).format('MM/DD/YYYY') : 'N/A'}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Date Discharged</ControlLabel>
                            <FormControl
                              type="text"
                              name="dateDischarged"
                              value={dateDischarged ? moment(dateDischarged).format('MM/DD/YYYY') : 'N/A'}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-3">
                          <FormGroup>
                            <ControlLabel>Date Regularized</ControlLabel>
                            <FormControl
                              type="text"
                              name="dateRegularized"
                              value={dateRegularized ? moment(dateRegularized).format('MM/DD/YYYY') : 'N/A'}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-6">
                          <FormGroup controlId="formControlsSelect">
                            <ControlLabel>TIN Classification</ControlLabel>
                            <FormControl 
                                readOnly
                                componentClass="select" 
                                name="tinClassification"
                                value={tinClassification}
                              >
                              <option value="">Select</option>
                            </FormControl>
                          </FormGroup>
                        </div>
                        <div className="col-md-6">
                          <FormGroup>
                            <ControlLabel>TIN Number</ControlLabel>
                            <FormControl
                              type="text"
                              name="tinNumber"
                              value={tinNumber}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-6">
                          <FormGroup>
                            <ControlLabel>SSS Number</ControlLabel>
                            <FormControl
                              type="text"
                              name="sssNumber"
                              value={sssNumber}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-4">
                          <FormGroup>
                            <ControlLabel>PHIC Number</ControlLabel>
                            <FormControl
                              type="text"
                              name="phicNumber"
                              value={phicNumber}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-4">
                          <FormGroup>
                            <ControlLabel>HDMF Number</ControlLabel>
                            <FormControl
                              type="text"
                              name="hdmfNumber"
                              value={hdmfNumber}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                        </div>
                        <div className="col-md-4">
                          <FormGroup>
                            <ControlLabel>ECOLA</ControlLabel>
                            <FormControl
                              type="text"
                              name="ecolaNumber"
                              value={ecolaNumber}
                              readOnly
                              placeholder=""
                            />
                            {this.errorMessage('ecolaNumber', "ECOLA can't be empty")}
                          </FormGroup>
                        </div>
                      </Row>
                      <Row>
                        <div className="col-md-4">
                          <FormGroup>
                            <ControlLabel>Superior</ControlLabel>
                            <EmployeeAsyncSelect
                                onChange={this.handleChange}
                                placeholder="Select Superior"
                            />
                            {/* <FormControl 
                                onChange={this.handleChange}
                                componentClass="select" 
                                name="superior"
                                value={superior && superior._id}
                              >
                              <option value="">Select</option>
                              {superiorSelectOptions.map(option => {
                                return (
                                  <option
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </option>
                                );
                              })}
                            </FormControl> */} 
                                            {this.errorMessage(
                                                "superior",
                                                "Superior can't be empty",
                                            )}
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-4">
                                        <FormGroup>
                                            <ControlLabel>
                                                Department
                                            </ControlLabel>
                                            <FormControl
                                                onChange={this.handleFormChange}
                                                componentClass="select"
                                                name="department"
                                                value={
                                                    department && department._id
                                                }
                                            >
                                                <option value="">Select</option>
                                                {departmentSelectOptions.map(
                                                    (option) => {
                                                        return (
                                                            <option
                                                                key={
                                                                    option.value
                                                                }
                                                                value={
                                                                    option.value
                                                                }
                                                            >
                                                                {option.label}
                                                            </option>
                                                        );
                                                    },
                                                )}
                                            </FormControl>
                                            {this.errorMessage(
                                                "department",
                                                "Department can't be empty",
                                            )}
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-4">
                                        <FormGroup>
                                            <ControlLabel>
                                                Position
                                            </ControlLabel>
                                            <FormControl
                                                onChange={this.handleFormChange}
                                                componentClass="select"
                                                name="position"
                                                value={position && position._id}
                                            >
                                                <option value="">Select</option>
                                                {positionSelectOptions.map(
                                                    (option) => {
                                                        return (
                                                            <option
                                                                key={
                                                                    option.value
                                                                }
                                                                value={
                                                                    option.value
                                                                }
                                                            >
                                                                {option.label}
                                                            </option>
                                                        );
                                                    },
                                                )}
                                            </FormControl>
                                            {this.errorMessage(
                                                "position",
                                                "Position can't be empty",
                                            )}
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    style={{
                                        margin: "0 auto 15px",
                                        padding: "10px 25px",
                                        border: "1px solid #999",
                                        borderRadius: "5px",
                                        display: "inline-block",
                                        width: "100%",
                                    }}
                                >
                                    <div className="col-md-12">
                                        <h6>Work Location</h6>
                                    </div>
                                    <div className="col-md-4">
                                        <FormGroup>
                                            <ControlLabel>
                                                Area
                                                <span className="required-star">
                                                    *
                                                </span>
                                            </ControlLabel>
                                            <FormControl
                                                onChange={this.handleFormChange}
                                                componentClass="select"
                                                name="locationArea"
                                                value={locationArea}
                                            >
                                                <option value="">Select</option>
                                                {areaSelectOptions.map(
                                                    (option) => {
                                                        return (
                                                            <option
                                                                key={
                                                                    option.value
                                                                }
                                                                value={
                                                                    option.value
                                                                }
                                                            >
                                                                {option.label}
                                                            </option>
                                                        );
                                                    },
                                                )}
                                            </FormControl>
                                            {this.errorMessage(
                                                "locationArea",
                                                "Area can't be empty",
                                            )}
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-4">
                                        <FormGroup>
                                            <ControlLabel>
                                                Province
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="locationProvince"
                                                value={locationProvince}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-4">
                                        <FormGroup>
                                            <ControlLabel>City</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="locationCity"
                                                value={locationCity}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    style={{
                                        margin: "0 auto 15px",
                                        padding: "10px 25px",
                                        border: "1px solid #999",
                                        borderRadius: "5px",
                                        display: "inline-block",
                                        width: "100%",
                                    }}
                                >
                                    <div className="col-md-12">
                                        <h6>Allowances</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Per Diem
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesPerDiem"
                                                value={allowancesPerDiem}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Gasoline
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesGasoline"
                                                value={allowancesGasoline}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>Meal (per day)</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesMeal"
                                                value={allowancesMeal}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Telephone
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesTelephone"
                                                value={allowancesTelephone}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Operational Expenses
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesOperational"
                                                value={allowancesOperational}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Transportation
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesTransportation"
                                                value={allowancesTransportation}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>Housing</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesHousing"
                                                value={allowancesHousing}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>Others</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="allowancesOthers"
                                                value={allowancesOthers}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <Row
                                    style={{
                                        margin: "0 auto 15px",
                                        padding: "10px 25px",
                                        border: "1px solid #999",
                                        borderRadius: "5px",
                                        display: "inline-block",
                                        width: "100%",
                                    }}
                                >
                                    <div className="col-md-12">
                                        <h6>Monthly Deductions</h6>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>Coop</ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="monthlyCoopDeduction"
                                                value={monthlyCoopDeduction}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Employee Vale
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="monthlyEmployeeValeDeduction"
                                                value={
                                                    monthlyEmployeeValeDeduction
                                                }
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Utility Bill
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="monthlyUtilityBillDeduction"
                                                value={
                                                    monthlyUtilityBillDeduction
                                                }
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Educational Loan
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="monthlyEducationalLoanDeduction"
                                                value={
                                                    monthlyEducationalLoanDeduction
                                                }
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Other monthly deductions
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="monthlyOtherDeduction"
                                                value={monthlyOtherDeduction}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                    <div className="col-md-3">
                                        <FormGroup>
                                            <ControlLabel>
                                                Uniform
                                            </ControlLabel>
                                            <FormControl
                                                type="text"
                                                name="monthlyUniformDeduction"
                                                value={monthlyUniformDeduction}
                                                onChange={this.handleFormChange}
                                                placeholder=""
                                            />
                                        </FormGroup>
                                    </div>
                                </Row>
                                <FormGroup controlId="formControlsSelect">
                                    <ControlLabel>Benefits</ControlLabel>
                                    <FormControl
                                        onChange={this.handleFormChange}
                                        componentClass="select"
                                        name="benefits"
                                        value={benefits}
                                    >
                                        <option value="">Select</option>
                                        <option value="companyPolicy">
                                            Company Policy
                                        </option>
                                        <option value="specialBenefits">
                                            Special Benefits
                                        </option>
                                    </FormControl>
                                    {this.errorMessage(
                                        "benefits",
                                        "Benefits can't be empty",
                                    )}
                                </FormGroup>
                                {benefits === "specialBenefits" && (
                                    <Row
                                        style={{
                                            margin: "0 auto 15px",
                                            padding: "10px 25px",
                                            border: "1px solid #999",
                                            borderRadius: "5px",
                                            display: "inline-block",
                                            width: "100%",
                                        }}
                                    >
                                        <div className="col-md-12">
                                            <h6>Special Benefits</h6>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsAccidentInsurance
                                                    }
                                                    name="benefitsAccidentInsurance"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Accident Insurance
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsHealthInsurance
                                                    }
                                                    name="benefitsHealthInsurance"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Health Insurance
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsBirthdayCheck
                                                    }
                                                    name="benefitsBirthdayCheck"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Birthday Check
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsLongevityPay
                                                    }
                                                    name="benefitsLongevityPay"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Longevity Pay
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsMeritIncrease
                                                    }
                                                    name="benefitsMeritIncrease"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Merit Increase
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsRiceIncentive
                                                    }
                                                    name="benefitsRiceIncentive"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Rice Incentive
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsSchoolBonus
                                                    }
                                                    name="benefitsSchoolBonus"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                School Bonus
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsSchoolAssistance
                                                    }
                                                    name="benefitsSchoolAssistance"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                School Assistance
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsUniform
                                                    }
                                                    name="benefitsUniform"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Uniform
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsRetirementProgram
                                                    }
                                                    name="benefitsRetirementProgram"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Retirement Program
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsGraduationGift
                                                    }
                                                    name="benefitsGraduationGift"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Graduation Gift
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsLengthOfServiceIncentive
                                                    }
                                                    name="benefitsLengthOfServiceIncentive"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Length Of Service Incentive
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsBurialAssistance
                                                    }
                                                    name="benefitsBurialAssistance"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Burial Assistance
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsWeddingGift
                                                    }
                                                    name="benefitsWeddingGift"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Wedding Gift
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsAnnualSalaryReview
                                                    }
                                                    name="benefitsAnnualSalaryReview"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Annual Salary Review
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsAnniversaryBonus
                                                    }
                                                    name="benefitsAnniversaryBonus"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Anniversary Bonus
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsRecognitionBonus
                                                    }
                                                    name="benefitsRecognitionBonus"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Recognition Bonus
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsMidYearBonus
                                                    }
                                                    name="benefitsMidYearBonus"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Mid Year Bonus
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsYearEndBonus
                                                    }
                                                    name="benefitsYearEndBonus"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Year End Bonus
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsSinulog
                                                    }
                                                    name="benefitsSinulog"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Sinulog
                                            </label>
                                        </div>
                                        <div className="formCheckbox">
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    defaultChecked={
                                                        benefitsFlowersAndCandles
                                                    }
                                                    name="benefitsFlowersAndCandles"
                                                    onChange={
                                                        this
                                                            .handleCheckboxChange
                                                    }
                                                />
                                                Flowers And Candles
                                            </label>
                                        </div>
                                    </Row>
                                )}
                                <Button
                                    bsStyle="primary"
                                    pullRight
                                    fill
                                    disabled={this.props.loading}
                                    onClick={() =>
                                        this.props.save(this.state.resource)
                                    }
                                >
                                    {this.props.loading
                                        ? "Updating..."
                                        : "Update Employee"}
                                </Button>
                                <div className="clearfix" />
                            </form>
                        }
                    />
                </Col>
            </Row>
        );
    }
}

export default UpdateForm;
